import environment from "environment";
import { Connect } from "./connect";
import { IOverduePatrimonialRightsPayload } from "./types";
export class OverduePatrimonialRightsConnect extends Connect {
  constructor() {
    const { apiKey, apiMsIntegration } = environment;
    const login = { idToken: sessionStorage.getItem("idToken") };
    super(apiMsIntegration, "", {
      apiKey,
      token: login.idToken ? login.idToken : ""
    });
  }

  async getOverduePatrimonialRightsReport(
    payload: IOverduePatrimonialRightsPayload
  ): Promise<any> {
    const params: Record<string, any> = {
      campaignId: payload.campaignId
    };

    if (payload.userId) {
      params.userId = payload.userId;
    }
    if (payload.userEmail) {
      params.userEmail = payload.userEmail;
    }
    if (payload.issuerPaymentID) {
      params.issuerPaymentID = payload.issuerPaymentID;
    }

    const response = await this.request({
      method: "get",
      service: "acc-integration/overdue-patrimonial-rights",
      params
    });
    return Promise.resolve(response?.data);
  }
}
